import { format } from 'date-fns';

import { SearchBarDateType } from '@utils/dateUtil';

export const URL_DATE_FORMAT = 'yyyy-MM-dd';

export const formatDateForUrl = (date: SearchBarDateType) => {
  if (!date) return null;

  return format(date, URL_DATE_FORMAT);
};
